// User Optiosn
export const TOGGLESIDE = "TOGGLE_SIDE_MENU";
export const SETROOMSIZE = "SET_ROOM_SIZE";
export const SETTYPESCREEN = "SET_TYPE_SCREEN";
export const SETMOBILITY = "SET_MOBILITY_SOLUTION";
export const SETOPS = "SET_OPS_OPTION";
export const SETVIDEO = "SET_VIDEO_CONFERENCING";
export const SETWIRELESS = "SET_WIRELESS_SHARING";
export const SETSUBDOMAIN = "SET_SUBDOMAIN_RESELLER";